import { AppAvatar } from "@lib/components/AppComponents";
import { booleanColor } from "@lib/helpers/ColorHelper";
import { providers } from "@lib/constants/Provider";
import { Provider } from "@lib/types/Provider";
import { AvatarSize } from "@lib/types/General";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";

type Props = {
  provider: Provider;
  maxWidth?: number;
  maxHeight?: number;
  fallback?: JSX.Element;
  preview?: boolean;
  size?: AvatarSize;
};
export default function ProviderLogo(props: Props) {
  const { provider, fallback, size = "medium" } = props;
  const { role } = useTypedSelector((state) => state.auth?.user);

  const logo =
    provider?.logo ||
    providers.find((item) => item.name === provider?.name)?.logo;

  if (role === AuthRoles.CustomerAgent) {
    return null;
  }

  if (!logo && fallback) {
    return fallback;
  }

  return (
    <AppAvatar
      src={logo}
      border={{ color: booleanColor(provider?.enabled) }}
      objectFit="contain"
      size={size as any}
      className="provider-logo-avatar"
    />
  );

  // return (
  //   <Image
  //     src={logo}
  //     style={{
  //       width: "150px",
  //       maxWidth: maxWidth ? `${maxWidth}px` : "150px",
  //       maxHeight: maxHeight ? `${maxHeight}px` : "100px",
  //       objectFit: "contain",
  //     }}
  //     preview={preview}
  //   />
  // );
}
